export const PREFIX_TERRAFORM_LEGACY = 'terraform.legacy';

export const WORKSPACE_ACCESS_ADMIN = 'workspace-access-admin';

export const TERRAFORM_ALL_PERMISSIONS = [
  `${PREFIX_TERRAFORM_LEGACY}.${WORKSPACE_ACCESS_ADMIN}`,
];
